import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import CTASection from '../components/CTASection';
import '../styles/teamWork.css';

// Sample team work images - you can replace these with actual work photos
const teamWorkImages = [
  {
    id: 1,
    src: '/images/team/teamAtWork.jpg',
    alt: 'Team installing landscape features',
    title: 'Professional Installation',
    category: 'installation',
    description: 'Our skilled team carefully installing new landscape elements'
  },
  // You can add more actual work photos here
  {
    id: 2,
    src: '/images/projects/sageDemoDriveProject1.jpeg', // Using existing project image as placeholder
    alt: 'Team maintaining garden beds',
    title: 'Garden Maintenance',
    category: 'maintenance',
    description: 'Regular maintenance keeps landscapes beautiful year-round'
  },
  {
    id: 3,
    src: '/images/landscape/landscapeHero.jpg', // Using existing image as placeholder
    alt: 'Team planning landscape design',
    title: 'Design Planning',
    category: 'design',
    description: 'Collaborative planning ensures perfect execution'
  },
  {
    id: 4,
    src: '/images/water/pondCreated1.jpg',
    alt: 'Team working on water feature',
    title: 'Water Feature Installation',
    category: 'installation',
    description: 'Expert installation of custom water features'
  },
  {
    id: 5,
    src: '/images/maintenance/HEROmaintenance1.jpeg', // Using existing image as placeholder
    alt: 'Seasonal maintenance work',
    title: 'Seasonal Care',
    category: 'maintenance',
    description: 'Providing expert care through every season'
  },
  {
    id: 6,
    src: '/images/flower/flowersBright1.jpg',
    alt: 'Team planting seasonal flowers',
    title: 'Flower Installation',
    category: 'installation',
    description: 'Adding vibrant seasonal color to landscapes'
  }
];

const TeamWork = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const categories = [
    { key: 'all', label: 'All Work' },
    { key: 'installation', label: 'Installation' },
    { key: 'maintenance', label: 'Maintenance' },
    { key: 'design', label: 'Design & Planning' }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? teamWorkImages 
    : teamWorkImages.filter(img => img.category === selectedCategory);

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className="team-work-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="team-work-hero">
        <div className="hero-content-overlay">
          <div className="hero-breadcrumb">
            <Link to="/team" className="breadcrumb-link">Team</Link>
            <span className="breadcrumb-separator">→</span>
            <span className="breadcrumb-current">Team at Work</span>
          </div>
          
          <h1 className="team-work-hero-title">Our Team in Action</h1>
          <p className="team-work-hero-subtitle">
            See the All Seasons difference through the skilled hands of our dedicated professionals
          </p>
        </div>
        
        <div className="hero-background">
          <img 
            src="/images/team/teamAtWork.jpg" 
            alt="All Seasons team working on landscape project"
            className="hero-bg-image"
          />
        </div>
      </section>

      {/* Filter Section */}
      <section className="work-gallery-section">
        <div className="work-gallery-container">
          <div className="gallery-header">
            <h2>Behind Every Beautiful Landscape</h2>
            <p>Watch our experienced team bring landscape visions to life with precision, care, and craftsmanship</p>
          </div>

          <div className="filter-buttons">
            {categories.map(category => (
              <button
                key={category.key}
                className={`filter-btn ${selectedCategory === category.key ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.key)}
              >
                {category.label}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="team-work-gallery">
            {filteredImages.map((image) => (
              <div 
                key={image.id} 
                className="gallery-item"
                onClick={() => openLightbox(image)}
              >
                <div className="gallery-image-container">
                  <img 
                    src={image.src} 
                    alt={image.alt}
                    className="gallery-image"
                    loading="lazy"
                  />
                  <div className="gallery-overlay">
                    <h3>{image.title}</h3>
                    <p>{image.description}</p>
                    <div className="view-indicator">
                      <span>View Full Size</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Back to Team Link */}
          <div className="back-to-team">
            <Link to="/team" className="btn-primary">
              ← Back to Meet the Team
            </Link>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>×</button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="lightbox-image"
            />
            <div className="lightbox-info">
              <h3>{selectedImage.title}</h3>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <CTASection 
        title="Ready to See Our Work in Person?"
        subtitle="Schedule a consultation and let our skilled team transform your outdoor space"
        galleryLink="/gallery"
        showEmergency={false}
      />
    </div>
  );
};

export default TeamWork;